export default __webpack_public_path__ + "static/media/render2.cfd2f14e.png";